import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { GoogleOAuthProvider } from '@react-oauth/google';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { captureReferralToken } from './utils/referral';

// Disabilita console.log se REACT_APP_ENABLE_LOGS !== 'true'
if (process.env.REACT_APP_ENABLE_LOGS !== 'true') {
  const noop = () => {};
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  // console.warn e console.error rimangono attivi per errori critici
}

captureReferralToken();

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <GoogleOAuthProvider clientId={googleClientId}>
    <HelmetProvider>
      <div className="min-h-screen bg-fpcwhite">
        <App />
      </div>
    </HelmetProvider>
  </GoogleOAuthProvider>
);
